import type {CommentingImplementation} from '@github-ui/conversations'
import {noop} from '@github-ui/noop'
import {useMemo} from 'react'

import {useCommentInfo} from './use-comment-info'
import {useFetchThread} from './use-fetch-commit-thread'

export function useDiffInlineCommenting(): CommentingImplementation {
  const commentInfo = useCommentInfo()
  const fetchThread = useFetchThread(commentInfo.canComment)

  return useMemo(
    () => ({
      batchingEnabled: false,
      commentSubjectType: 'commit',
      multilineEnabled: false,
      resolvingEnabled: false,
      suggestedChangesEnabled: false,
      addThread: noop,
      addThreadReply: noop,
      deleteComment: noop,
      editComment: noop,
      pendingSuggestedChangesBatch: [],
      submitSuggestedChanges: noop,
      addSuggestedChangeToPendingBatch: noop,
      removeSuggestedChangeFromPendingBatch: noop,
      addFileLevelThread: noop,
      resolveThread: noop,
      unresolveThread: noop,
      fetchThread,
      commentBoxConfig: {
        pasteUrlsAsPlainText: false,
        useMonospaceFont: false,
      },
    }),
    [fetchThread],
  )
}
